import Inicio from './components/en'
import React, { useContext } from 'react';

import En from './components/en'
import Ch from './components/ch'
import Error404 from './components/systempages/error404'
import ErrorC from './components/systempages/errorconnection'
import './App.css'
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<Inicio />} />
        <Route exact path="/en" element={<En />} />
        <Route exact path="/ch" element={<Ch />} />
        {/* <Route exact path="/error404" element={<Error404 />} /> */}
        <Route exact path="/errorconnection" element={<ErrorC />} />
        <Route exact path="*" element={<Error404 />} />
      </Routes>
    </>
  );
}

export default App;
